import { render, staticRenderFns } from "./mainDrawing.vue?vue&type=template&id=07d757d6&scoped=true"
import script from "./mainDrawing.vue?vue&type=script&lang=js"
export * from "./mainDrawing.vue?vue&type=script&lang=js"
import style0 from "./mainDrawing.vue?vue&type=style&index=0&id=07d757d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d757d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d757d6')) {
      api.createRecord('07d757d6', component.options)
    } else {
      api.reload('07d757d6', component.options)
    }
    module.hot.accept("./mainDrawing.vue?vue&type=template&id=07d757d6&scoped=true", function () {
      api.rerender('07d757d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/mainDrawing.vue"
export default component.exports